import { useTranslation } from 'react-i18next';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { PhoneInput } from '@Components/inputs/Phone';
import { SSNInput } from '@Components/inputs/SSNInput';
import { DateOfBirthInput } from '@Components/inputs/DateOfBirthInput';
import { getRouteOrdinal, RoutesMap } from '@Router/router.types';
import type { RegionCode } from 'google-libphonenumber';

export const UBOIdentityUS = () => {
  const { t } = useTranslation();
  const baseTabIndex = getRouteOrdinal(RoutesMap.ADD_OWNER);

  return (
    <div className='w-full'>
      <Heading.H8 fontWeight={FontWeight.MEDIUM} className='mb-[16px]'>
        {t('pages.addOwner.identitySection.title')}
      </Heading.H8>

      <div className='grid grid-cols-1 sm:grid-cols-2 gap-x-[24px]'>
        <div className='relative'>
          <SSNInput tabIndex={baseTabIndex + 5} />
        </div>
        <DateOfBirthInput tabIndex={baseTabIndex + 6} />

        <div className='z-[999]'>
          <PhoneInput
            tabIndex={baseTabIndex + 7}
            isSelectMenuDisabled={true}
            filteredCountries={['US'] as RegionCode[]}
          />
        </div>
      </div>
    </div>
  );
};
